import React, { useState, useEffect } from "react";
import { FiPlus, FiEdit2, FiTrash2, FiMapPin, FiX, FiCheck } from "react-icons/fi";
import { useAppContext } from "../../AppContext";
import { MyDomain } from "../../App";

function Modal({ title, onClose, children }) {
  return (
    <div
      onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 999, padding: 20 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 420, boxShadow: "0 24px 60px rgba(0,0,0,0.18)", overflow: "hidden" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 20px", borderBottom: "1px solid #e5e7eb" }}>
          <span style={{ fontSize: 16, fontWeight: 700, color: "#1a1a1a" }}>{title}</span>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", display: "flex" }}>
            <FiX size={20} />
          </button>
        </div>
        <div style={{ padding: "20px" }}>{children}</div>
      </div>
    </div>
  );
}

export default function AddressSection() {
  const { User } = useAppContext();
  const user = User || (() => { try { return JSON.parse(localStorage.getItem("user")); } catch { return null; } })();

  const displayName = user?.fullName || user?.FullName || "";
  const displayPhone = (user?.countryNumber || user?.CountryNumber || "") + (user?.phoneNumber || user?.PhoneNumber || "");

  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [cityInput, setCityInput] = useState("");
  const [saving, setSaving] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    if (!user?.id) { setLoading(false); return; }
    fetch(`${MyDomain}Address2/GetUserAddresses/${user.id}`)
      .then((r) => r.json())
      .then((data) => { setAddresses(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [user?.id]);

  const openAdd = () => { setEditing(null); setCityInput(""); setModalOpen(true); };
  const openEdit = (addr) => { setEditing(addr); setCityInput(addr.city || ""); setModalOpen(true); };
  const closeModal = () => { setModalOpen(false); setEditing(null); setCityInput(""); };

  const handleSave = async () => {
    if (!cityInput.trim()) return;
    setSaving(true);
    try {
      if (editing) {
        const res = await fetch(`${MyDomain}Address2/UpdateAddress`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: editing.id, userId: user.id, city: cityInput.trim() }),
        });
        const data = await res.json();
        if (Array.isArray(data)) setAddresses(data);
      } else {
        const res = await fetch(`${MyDomain}Address2/AddAddress`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: user.id, city: cityInput.trim() }),
        });
        const data = await res.json();
        if (Array.isArray(data)) setAddresses(data);
      }
      closeModal();
    } catch (err) { console.error("Save address failed", err); }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    setDeletingId(id);
    try {
      const res = await fetch(`${MyDomain}Address2/DeleteAddress/${id}`, { method: "DELETE" });
      const data = await res.json();
      if (Array.isArray(data)) setAddresses(data);
    } catch (err) { console.error("Delete address failed", err); }
    setDeletingId(null);
  };

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 12, borderBottom: "1px solid #e5e7eb" }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: "#1a1a1a", margin: 0 }}>Address</h2>
        <button
          onClick={openAdd}
          style={{ display: "flex", alignItems: "center", gap: 6, background: "#e11d48", color: "#fff", border: "none", borderRadius: 10, padding: "9px 16px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
        >
          <FiPlus size={15} /> Add Address
        </button>
      </div>

      {loading && <p style={{ color: "#9ca3af", fontSize: 15 }}>Loading addresses…</p>}

      {/* Empty */}
      {!loading && addresses.length === 0 && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, padding: "48px 0" }}>
          <div style={{ width: 60, height: 60, borderRadius: "50%", background: "rgba(225,29,72,0.08)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <FiMapPin size={26} color="#e11d48" />
          </div>
          <p style={{ color: "#1a1a1a", fontWeight: 700, fontSize: 16, margin: 0 }}>No addresses yet</p>
          <p style={{ color: "#9ca3af", fontSize: 14, margin: 0 }}>Add your first address to get started.</p>
          <button onClick={openAdd} style={{ marginTop: 4, background: "#e11d48", color: "#fff", border: "none", borderRadius: 10, padding: "10px 24px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
            Add Address
          </button>
        </div>
      )}

      {/* Address cards */}
      {!loading && addresses.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {addresses.map((addr) => (
            <div
              key={addr.id}
              style={{ display: "flex", alignItems: "center", gap: 14, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 12, padding: "14px 16px" }}
            >
              <div style={{ width: 40, height: 40, borderRadius: "50%", background: "rgba(225,29,72,0.08)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <FiMapPin size={18} color="#e11d48" />
              </div>

              <div style={{ flex: 1 }}>
                {displayName && (
                  <p style={{ margin: 0, fontSize: 15, fontWeight: 600, color: "#1a1a1a" }}>{displayName}</p>
                )}
                {displayPhone && (
                  <p style={{ margin: "3px 0 0", fontSize: 13, color: "#6b7280" }}>{displayPhone}</p>
                )}
                <p style={{ margin: "3px 0 0", fontSize: 13, color: "#6b7280" }}>{addr.city}</p>
              </div>

              <button
                onClick={() => openEdit(addr)}
                style={{ background: "none", border: "1px solid #e5e7eb", borderRadius: 8, padding: "7px 10px", cursor: "pointer", color: "#555", display: "flex", alignItems: "center", gap: 5, fontSize: 13, fontWeight: 500 }}
              >
                <FiEdit2 size={13} /> Edit
              </button>

              <button
                onClick={() => handleDelete(addr.id)}
                disabled={deletingId === addr.id}
                style={{ background: "none", border: "1px solid #fecdd3", borderRadius: 8, padding: "7px 10px", cursor: "pointer", color: "#e11d48", display: "flex", alignItems: "center", gap: 5, fontSize: 13, fontWeight: 500, opacity: deletingId === addr.id ? 0.5 : 1 }}
              >
                <FiTrash2 size={13} /> {deletingId === addr.id ? "…" : "Delete"}
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Modal — city only */}
      {modalOpen && (
        <Modal title={editing ? "Edit Address" : "Add Address"} onClose={closeModal}>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>City</label>
              <input
                type="text"
                placeholder="Enter city name…"
                value={cityInput}
                onChange={(e) => setCityInput(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") handleSave(); }}
                autoFocus
                style={{ width: "100%", padding: "10px 12px", borderRadius: 10, boxSizing: "border-box", border: "1.5px solid #e5e7eb", fontSize: 14, color: "#1a1a1a", background: "#fff", outline: "none" }}
              />
            </div>

            <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
              <button onClick={closeModal} style={{ flex: 1, background: "none", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "11px 0", fontSize: 14, fontWeight: 600, cursor: "pointer", color: "#555" }}>
                Cancel
              </button>
              <button
                onClick={handleSave}
                disabled={!cityInput.trim() || saving}
                style={{ flex: 1, background: cityInput.trim() ? "#e11d48" : "#d1d5db", color: "#fff", border: "none", borderRadius: 10, padding: "11px 0", fontSize: 14, fontWeight: 600, cursor: cityInput.trim() ? "pointer" : "not-allowed", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, opacity: saving ? 0.7 : 1 }}
              >
                <FiCheck size={15} /> {saving ? "Saving…" : editing ? "Save Changes" : "Add Address"}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
